import React from 'react'
import _ from 'lodash/fp'
import {jwtPostFetcher} from "../../utils/authFetch";
import {getJwt} from "../../hooks/useJwt";
import {lazyCustomIntl} from "../../components/I18NProvider";


export const DEFAULT_ADDITIONAL_FIELDS = (intl) => ([
  intl.formatMessage({
    defaultMessage:'Summary for the patient',
    description: 'Request additional information, default fields, summary for the patient'
  }),
  intl.formatMessage({
    defaultMessage: 'Background information',
    description: 'Request additional information, default fields, background information'
  }),
  intl.formatMessage({
    defaultMessage: 'Recommendation and links',
    description: 'Request additional information, default fields, recommendation and links'
  })
])

// export const LEGAL_ADDITIONAL_FIELDS = [
//   'Summary for the client',
//   'Background information',
//   'Recommendation and links'
// ]

export const LEGAL_ADDITIONAL_FIELDS = []

const defaultCreateCaseTransform = (intl) => _.flow(
  _.update('categories', (categories) => (categories || []).filter(_.identity).map(({id})=> id)),
  _.set('caseInfo.additionalFields', DEFAULT_ADDITIONAL_FIELDS(intl).map((title,i) => ({title,id: Date.now().toString(36)+i,content:''})))
)

const createLegalCaseTransform = _.flow(
  _.update('categories', (categories) => (categories || []).filter(_.identity).map(({id})=> id)),
  _.set('caseInfo.additionalFields', LEGAL_ADDITIONAL_FIELDS.map((title,i) => ({title,id: Date.now().toString(36)+i,content:''})))
)

export const createCaseTransform = async (data, isLegal) => {
  if (isLegal) {
    return createLegalCaseTransform(data)
  } else {
    const intl = await lazyCustomIntl.use(data.caseInfo.preferredLanguage || "en-US").promise()
    return defaultCreateCaseTransform(intl)(data)
  }
}